import { createAsyncThunk } from "@reduxjs/toolkit";
import { getFirebaseAuthToken } from "../../helpers/firebase_helper";
import config from "../../config";

export const validateInviteCode = createAsyncThunk(
    "inviteCode/validateInviteCode",
    async ({
        inviteCode,
        role
    }) => {
        try {
            const token = await getFirebaseAuthToken();
            const response = await fetch(
                `${config.api.API_URL}/dashboard/invite-code/validate`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `${token}`,
                    },
                    body: JSON.stringify({ inviteCode, role }),
                }
            );

            if (!response.ok) {
                throw new Error("Error validating invite code");
            }

            const data = await response.json();
            return data;
        } catch (error) {
            throw error;
        }
    }
);